<template>
  <div
    class="wrap"
    v-if="info"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <!-- 公司信息 -->
    <div class="title">公司信息</div>
    <div class="box">
      <div class="item" style="padding-top: 25px" v-if="info.companyName">
        <div class="left">公司名称：</div>
        <div class="right2">{{ info.companyName }}</div>
      </div>
      <div class="item" v-if="info.companyNameShort">
        <div class="left">公司简称：</div>
        <div class="right">{{ info.companyNameShort }}</div>
      </div>
      <div class="item" v-if="info.companyNameEn">
        <div class="left">英文名称：</div>
        <div class="right2">{{ info.companyNameEn }}</div>
      </div>
      <div class="item" v-if="info.unifiedCode">
        <div class="left">统一信用代码：</div>
        <div class="right">{{ info.unifiedCode }}</div>
      </div>
      <div class="item">
        <div class="left">属于子公司：</div>
        <div class="right">{{ info.isBelongChild ? "是" : "否" }}</div>
      </div>
      <div class="item" v-if="info.website">
        <div class="left">网址：</div>
        <div class="right2">
          <a :href="info.website">{{ info.website }}</a>
        </div>
      </div>
      <div class="item">
        <div class="left">公司地址：</div>
        <div class="right">
          {{ info.country }}·{{ info.province }}·{{ info.city
          }}{{ info.county ? "·" + info.county : "" }}
        </div>
      </div>
      <div class="item" v-if="info.address">
        <div class="left">详细地址：</div>
        <div class="right2">{{ info.address }}</div>
      </div>
      <div class="item" v-if="info.postcode">
        <div class="left">邮编：</div>
        <div class="right">{{ info.postcode }}</div>
      </div>
      <div class="item" v-if="info.imgBusinessLicense">
        <div class="left">营业执照：</div>
        <div class="right">
          <img
            :src="info.imgBusinessLicense.url.url"
            width="75"
            v-if="
              info.imgBusinessLicense.url && info.imgBusinessLicense.url.url
            "
          />
          <img
            :src="info.imgBusinessLicense.url"
            width="75"
            v-else="info.imgBusinessLicense.url"
          />
        </div>
      </div>
    </div>
    <!-- 公司信息 -->

    <!-- 联系人信息 -->
    <div class="title">公司信息</div>
    <div class="box">
      <div class="box_title">展会联系人</div>
      <div class="item" v-if="info.linkMan">
        <div class="left">姓名：</div>
        <div class="right">{{ info.linkMan }}</div>
      </div>
      <div class="item" v-if="info.linkTitle">
        <div class="left">职务：</div>
        <div class="right">{{ info.linkTitle }}</div>
      </div>
      <div class="item" v-if="info.linkMob">
        <div class="left">手机：</div>
        <div class="right">
          <a :href="`tel:${info.linkMob}`">{{ info.linkMob }}</a>
        </div>
      </div>
      <div class="item" v-if="info.linkEmail">
        <div class="left">邮箱：</div>
        <div class="right">{{ info.linkEmail }}</div>
      </div>
      <div class="item" v-if="info.linkCode || info.linkTelephone">
        <div class="left">座机：</div>
        <div class="right">
          <a :href="`tel:${info.linkCode}${info.linkTelephone}`"
            >{{ info.linkCode }} {{ info.linkTelephone }}</a
          >
        </div>
      </div>
      <div class="item" v-if="info.linkQQ">
        <div class="left">QQ：</div>
        <div class="right">{{ info.linkQQ }}</div>
      </div>
      <div class="item" v-if="info.linkWeChat">
        <div class="left">微信：</div>
        <div class="right">{{ info.linkWeChat }}</div>
      </div>
    </div>
    <!-- 联系人信息 -->

    <!-- 市场负责人 -->
    <div class="box">
      <div class="box_title">市场负责人</div>
      <div class="item" v-if="info.leader">
        <div class="left">姓名：</div>
        <div class="right">{{ info.leader }}</div>
      </div>
      <div class="item" v-if="info.leaderTitle">
        <div class="left">职务：</div>
        <div class="right">{{ info.leaderTitle }}</div>
      </div>
      <div class="item" v-if="info.leaderMob">
        <div class="left">手机：</div>
        <div class="right">
          <a :href="`tel:${info.leaderMob}`">{{ info.leaderMob }}</a>
        </div>
      </div>
      <div class="item" v-if="info.leaderEmail">
        <div class="left">邮箱：</div>
        <div class="right">{{ info.leaderEmail }}</div>
      </div>
      <div class="item" v-if="info.leaderCode || info.leaderTelephone">
        <div class="left">座机：</div>
        <div class="right">
          <a :href="`tel:${info.leaderCode}${info.leaderTelephone}`"
            >{{ info.leaderCode }} {{ info.leaderTelephone }}</a
          >
        </div>
      </div>
      <div class="item" v-if="info.leaderQQ">
        <div class="left">QQ：</div>
        <div class="right">{{ info.leaderQQ }}</div>
      </div>
      <div class="item" v-if="info.leaderWeChat">
        <div class="left">微信：</div>
        <div class="right">{{ info.leaderWeChat }}</div>
      </div>
    </div>
    <!-- 市场负责人 -->

    <!-- 开票信息 -->
    <div class="title">开票信息</div>
    <div class="box">
      <template v-if="info.invoiceTitle">
        <div class="item" v-if="info.invoiceTitle">
          <div class="left">发票抬头：</div>
          <div class="right2">{{ info.invoiceTitle }}</div>
        </div>
        <div class="item" v-if="info.invoiceCode">
          <div class="left">税号：</div>
          <div class="right">{{ info.invoiceCode }}</div>
        </div>
        <div class="item" v-if="info.invoiceAddress">
          <div class="left">单位地址：</div>
          <div class="right2">{{ info.invoiceAddress }}</div>
        </div>
        <div class="item" v-if="info.invoiceTelephone">
          <div class="left">电话号码：</div>
          <div class="right">{{ info.invoiceTelephone }}</div>
        </div>
        <div class="item" v-if="info.invoiceBank">
          <div class="left">开户银行：</div>
          <div class="right2">{{ info.invoiceBank }}</div>
        </div>
        <div class="item" v-if="info.invoiceBankAccount">
          <div class="left">银行账号：</div>
          <div class="right">{{ info.invoiceBankAccount }}</div>
        </div>
        <div class="item" v-if="info.invoiceType">
          <div class="left">开票类型：</div>
          <div class="right">{{ info.invoiceType }}</div>
        </div>
        <div class="item">
          <div class="left">发票邮寄地址：</div>
          <div class="right2">
            {{ info.invoiceMalingCountry }}·{{ info.invoiceMalingProvince }}·{{
              info.invoiceMalingCity
            }}
          </div>
        </div>
        <div class="item" v-if="info.invoiceMalingCode">
          <div class="left">邮编：</div>
          <div class="right">{{ info.invoiceMalingCode }}</div>
        </div>
        <div class="item" v-if="info.invoiceMalingAdress">
          <div class="left">详细地址：</div>
          <div class="right2">{{ info.invoiceMalingAdress }}</div>
        </div>
        <div class="item" v-if="info.invoiceRecivePerson">
          <div class="left">发票收件人：</div>
          <div class="right">{{ info.invoiceRecivePerson }}</div>
        </div>
        <div class="item" v-if="info.invoiceReciveTel">
          <div class="left">收件人电话：</div>
          <div class="right">
            <a :href="`tel:${info.invoiceReciveTel}`">{{
              info.invoiceReciveTel
            }}</a>
          </div>
        </div>
      </template>
      <div class="empty" v-else>暂不提供，后续提交</div>
    </div>
    <!-- 开票信息 -->

    <!-- 开票信息 -->
    <div class="title">参展意向</div>
    <div class="box">
      <div class="box_title">{{ info.exhibitionName }}</div>
      <div class="item">
        <div class="left">展区：</div>
        <div class="right">{{ info.areaName }}</div>
      </div>
      <div class="item">
        <div class="left">展位类型：</div>
        <div class="right">{{ info.boothType }}</div>
      </div>
      <div class="item">
        <div class="left">预定面积：</div>
        <div class="right">{{ info.area }}㎡</div>
      </div>
      <div class="item">
        <div class="left">参展展品：</div>
        <div class="right2">{{ info.productName }}</div>
      </div>
      <div class="item" v-if="info.planAd">
        <div class="left">计划投放广告：</div>
        <div class="right">{{ info.planAd }}</div>
      </div>
    </div>
    <!-- 开票信息 -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      info: null,
      loading: true,
    };
  },
  methods: {
    ...mapActions({
      applyOMGetById: "mobileBackend/applyOMGetById",
    }),
    async init() {
      let res = await this.applyOMGetById({
        dePjNameGroupId: this.$route.query.dePjNameGroupId,
        exhibitionId: this.$route.query.exhibitionId,
        applyCompanyId: this.$route.query.applyCompanyId,
      });
      if (res) {
        if (res.imgBusinessLicense) {
          res.imgBusinessLicense = JSON.parse(res.imgBusinessLicense);
        }
        this.info = res;
        console.log("info", this.info);
      }
      if (res) {
        this.loading = false;
      }
    },
  },
  created() {
    document.title = "企业详情";
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 15px;
  display: flex;
  align-items: center;
  &::before {
    width: 3px;
    height: 15px;
    background-color: #0782ff;
    border-radius: 1px;
    content: "";
    display: inline-block;
    margin-right: 7px;
  }
}
.box {
  margin: 15px;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 5px;
  overflow: hidden;
  &_title {
    padding: 10px 15px;
    border-bottom: 1px solid #f7f7f7;
  }
  .item {
    display: flex;
    margin: 15px;
    font-size: 13px;
    color: #333;
  }
  .left {
    width: 100px;
    text-align: right;
  }
  .right {
    width: calc(100% - 100px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .right2 {
    width: calc(100% - 100px);
  }
}
.empty {
  line-height: 75px;
  text-align: center;
  background-color: #fff;
}
</style>
